import Add16 from '@carbon/icons-react/es/add/16';
import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { ReactComponent as Icon } from 'assets/svgs/spaces.svg';
import { Button } from 'components/atoms/button';
import { EmptyState, EmptyStateContainer } from 'components/atoms/empty-state';
import { useDistractionFreeMode } from 'hooks/use-distraction-free-mode';

const SpaceIcon = styled(Icon)`
  fill: currentColor;
  color: var(--cool-gray-70);
`;

export const EmptySpaces: FC<{
  onSpaceAdd: (isPrivate: boolean) => void;
}> = ({ onSpaceAdd }) => {
  const { exit } = useDistractionFreeMode();

  return (
    <EmptyStateContainer $transparent>
      <EmptyState
        image={<SpaceIcon />}
        title={<FormattedMessage id="projects.spaces.empty.title" />}
        message={<FormattedMessage id="projects.spaces.empty.message" />}
      >
        <Button
          onClick={() => {
            onSpaceAdd(true);
            exit();
          }}
          iconPlacement="right"
          icon={<Add16 />}
          type="primary"
          data-cy="projects.spaces.add.new"
        >
          <FormattedMessage id="projects.spaces.add.text" />
        </Button>
      </EmptyState>
    </EmptyStateContainer>
  );
};
